/* ============================================================================
   FLUXBEAR · assets/theme.js —— 全站交互（界面层）
   依赖 assets/cart.js（数据层）—— 所以 base 在 theme.liquid 里先加载 cart.js

   包含：
     1. 通用小工具（toast / 锁滚动 / 格式化）
     2. 进场动画（滚动到才出现）
     3. 导航（移动菜单 / 滚动隐藏 / 搜索面板）
     4. 购物车抽屉（打开关闭 / 数量加减 / 删除 / 备注 / 局部刷新）
     5. 商品卡片快捷加购
     6. 商品详情页（变体选择 / 主图切换 / 数量 / 加购 / 放大灯箱）
     7. 订阅表单
     8. 收藏（本地，纯浏览体验）
   ========================================================================== */
(function () {
  'use strict';

  /* ================================================ 1. 通用小工具 */
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  };

  var toastEl = null;
  var toastTimer = null;

  /**
   * 全局提示条
   * @param {string} msg  文案
   * @param {string} type 'ok' | 'error'
   */
  function toast(msg, type) {
    if (!toastEl) toastEl = $('#FluxToast');
    if (!toastEl || !msg) return;
    toastEl.textContent = msg;
    toastEl.className = 'toast show' + (type === 'error' ? ' toast--error' : '');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.className = 'toast' + (type === 'error' ? ' toast--error' : '');
    }, 3200);
  }

  function lockScroll(on) {
    document.body.classList.toggle('lock', !!on);
  }

  /* 把 cents 变成 $12.34。★ 必须除 100，Shopify 价格单位是「分」 */
  function money(cents) {
    var symbol = (window.FluxMoneyFormat && window.FluxMoneyFormat.symbol) || '$';
    var n = (Number(cents) || 0) / 100;
    return symbol + n.toFixed(2).replace(/\.00$/, '');
  }

  /* ================================================ 2. 进场动画 */
  function initReveal() {
    var nodes = $$('.reveal');
    if (!nodes.length) return;

    /* 用户系统里开了「减少动画」→ 直接全部显示，不做动画 */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      nodes.forEach(function (n) { n.classList.add('in'); });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target); /* 出现一次就够了，取消监听省性能 */
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    nodes.forEach(function (n) { io.observe(n); });
  }

  /* 数字滚动（首页统计用） */
  function initCountUp() {
    var nodes = $$('[data-count-to]');
    if (!nodes.length || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var raw = el.getAttribute('data-count-to');
        var suffix = el.getAttribute('data-count-suffix') || '';
        var target = parseFloat(raw);
        if (isNaN(target)) { io.unobserve(el); return; }

        var start = performance.now();
        var dur = 1100;
        function tick(now) {
          var p = Math.min(1, (now - start) / dur);
          /* easeOutCubic：先快后慢，看起来更自然 */
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased) + suffix;
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
        io.unobserve(el);
      });
    }, { threshold: 0.5 });

    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ================================================ 3. 导航 */
  function initNav() {
    /* --- 移动端汉堡菜单 --- */
    var burger = $('#FluxBurger');
    var mobileMenu = $('#FluxMobileMenu');
    if (burger && mobileMenu) {
      burger.addEventListener('click', function () {
        var open = mobileMenu.classList.toggle('open');
        burger.classList.toggle('is-open', open);
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        lockScroll(open);
      });
      $$('[data-mm-close]', mobileMenu).forEach(function (b) {
        b.addEventListener('click', function () {
          mobileMenu.classList.remove('open');
          burger.classList.remove('is-open');
          burger.setAttribute('aria-expanded', 'false');
          lockScroll(false);
        });
      });
      /* 点了菜单里的链接就自动关掉 */
      $$('a', mobileMenu).forEach(function (a) {
        a.addEventListener('click', function () {
          mobileMenu.classList.remove('open');
          burger.classList.remove('is-open');
          lockScroll(false);
        });
      });
    }

    /* --- 向下滚动收起导航条 --- */
    var nav = $('#FluxNav');
    if (nav) {
      var lastY = window.pageYOffset;
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var y = window.pageYOffset;
          /* 菜单开着 / 搜索开着的时候不要动导航 */
          var busy = document.body.classList.contains('lock');
          if (!busy) {
            if (y > lastY && y > 200) {
              nav.classList.add('is-hidden');       /* 下滚：藏起来 */
            } else {
              nav.classList.remove('is-hidden');    /* 上滚：立刻出现 */
            }
          }
          lastY = y;
          ticking = false;
        });
      }, { passive: true });
    }

    /* --- 搜索面板 --- */
    var searchOverlay = $('#FluxSearchOverlay');
    var searchInput = $('#FluxSearchInput');
    var searchTrigger = $('#FluxSearchOpen');
    if (searchOverlay) {
      function openSearch() {
        searchOverlay.classList.add('open');
        lockScroll(true);
        /* ★ 延迟聚焦：等面板滑入动画开始后再聚焦，
           否则某些浏览器会因为元素还没可见而聚焦失败 */
        setTimeout(function () { if (searchInput) searchInput.focus(); }, 220);
      }
      function closeSearch() {
        searchOverlay.classList.remove('open');
        lockScroll(false);
      }
      if (searchTrigger) searchTrigger.addEventListener('click', openSearch);
      $$('[data-search-close]', searchOverlay).forEach(function (b) {
        b.addEventListener('click', closeSearch);
      });
      searchOverlay.addEventListener('click', function (e) {
        if (e.target === searchOverlay) closeSearch();
      });
      $$('[data-search-suggest]', searchOverlay).forEach(function (a) {
        a.addEventListener('click', function () {
          if (searchInput) searchInput.value = a.getAttribute('data-search-suggest');
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeSearch();
      });
    }
  }

  /* ================================================ 4. 购物车抽屉 */
  var Cart = {
    drawer: null,
    overlay: null,
    body: null,
    countEls: [],

    init: function () {
      this.drawer = $('#FluxCartDrawer');
      this.overlay = $('#FluxOverlay');
      this.body = $('#FluxCartBody');
      this.countEls = $$('[data-cart-count-bubble]');

      if (!this.drawer) return;

      var self = this;

      /* 打开抽屉的触发点：导航上的 Bag 按钮、加购后自动打开 */
      $$('[data-cart-open]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          self.open();
        });
      });

      /* 关闭 */
      $$('[data-cart-close]', this.drawer).forEach(function (b) {
        b.addEventListener('click', function () { self.close(); });
      });
      if (this.overlay) {
        this.overlay.addEventListener('click', function () { self.close(); });
      }
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') self.close();
      });

      /* --- 事件委托：抽屉里的按钮是动态渲染的，
             所以不能直接绑在按钮上，要绑在容器上再判断来源 --- */
      this.drawer.addEventListener('click', function (e) {
        var qtyBtn = e.target.closest('[data-qty-change]');
        if (qtyBtn) {
          e.preventDefault();
          self.changeQty(
            qtyBtn.getAttribute('data-qty-change'),
            Number(qtyBtn.getAttribute('data-qty-delta'))
          );
          return;
        }
        var rmBtn = e.target.closest('[data-line-remove]');
        if (rmBtn) {
          e.preventDefault();
          self.removeLine(rmBtn.getAttribute('data-line-remove'));
          return;
        }
      });

      /* --- 备注：失焦时保存 --- */
      this.drawer.addEventListener('change', function (e) {
        if (e.target && e.target.id === 'FluxCartNote') {
          window.FluxCart.updateNote(e.target.value).catch(function () {
            toast('Could not save your note. Please try again.', 'error');
          });
        }
      });
    },

    open: function () {
      if (!this.drawer) return;
      /* 收藏抽屉和购物袋共用遮罩，打开购物袋前先收起收藏 */
      if (window.FluxWish && window.FluxWish.close) window.FluxWish.close();
      this.drawer.classList.add('open');
      this.drawer.setAttribute('aria-hidden', 'false');
      if (this.overlay) {
        this.overlay.hidden = false;
        /* 强制一次重排，否则 hidden 刚移除时 opacity 过渡不会触发 */
        void this.overlay.offsetWidth;
        this.overlay.classList.add('open');
      }
      lockScroll(true);
      /* 把焦点移到关闭按钮，方便键盘和读屏用户 */
      var closeBtn = $('[data-cart-close]', this.drawer);
      if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 260);
    },

    close: function () {
      if (!this.drawer) return;
      this.drawer.classList.remove('open');
      this.drawer.setAttribute('aria-hidden', 'true');
      if (this.overlay) {
        this.overlay.classList.remove('open');
        lockScroll(false);
      }
    },

    /* ---- 用最新数据重渲染购物车相关的界面 ---- */
    render: function (cart) {
      if (!cart) return;

      /* ① 更新所有「件数气泡」 */
      var count = cart.item_count || 0;
      this.countEls.forEach(function (el) {
        el.textContent = count;
        /* 加个弹一下的动画，给用户即时反馈 */
        el.classList.remove('is-bump');
        void el.offsetWidth;
        el.classList.add('is-bump');
      });

      /* ② 如果 Shopify 直接返回了 sections 的 HTML，整块替换。
           这是最省事也最不会出错的做法：布局、金额、按钮状态
           全部由服务端算好，前端不用自己拼。 */
      if (cart.sections) {
        var drawerHtml = cart.sections.cartDrawer;
        if (drawerHtml && this.drawer) {
          var tmp = document.createElement('div');
          tmp.innerHTML = drawerHtml;
          var fresh = tmp.querySelector('#FluxCartDrawer') || tmp.firstElementChild;
          if (fresh) {
            /* 保留当前是否打开的状态 */
            var wasOpen = this.drawer.classList.contains('open');
            this.drawer.innerHTML = fresh.innerHTML;
            this.drawer.className = fresh.className || 'drawer';
            this.drawer.id = 'FluxCartDrawer';
            if (wasOpen) this.drawer.classList.add('open');
            /* 替换后重新抓一次 body 引用 */
            this.body = $('#FluxCartBody');
          }
        }
      }
    },

    /* ---- 加购 ---- */
    add: function (variantId, quantity, props, opts) {
      opts = opts || {};
      var self = this;
      var drawerNode = this.drawer;
      if (drawerNode) drawerNode.classList.add('cart-loading');

      /* ★ 兜底：数据层没加载时，必须「返回一个失败的 Promise」，
         不能让它同步抛异常。
         踩过的坑：以前这里直接写 window.FluxCart.add(...)，
         一旦 cart.js 没被引入，window.FluxCart 是 undefined，
         这一行会同步抛 TypeError —— 异常发生在 .then/.catch 挂上去之前，
         所以调用方（加购按钮）的 .catch 永远没机会执行，
         按钮就卡在 Adding… 不动，用户以为在下单其实什么都没发生。
         现在改成主动 reject，调用方照常走 .catch，按钮会复位并弹出错误提示。 */
      if (!window.FluxCart || typeof window.FluxCart.add !== 'function') {
        if (drawerNode) drawerNode.classList.remove('cart-loading');
        var missing = new Error('Cart is temporarily unavailable. Please refresh the page.');
        toast(missing.message, 'error');
        return Promise.reject(missing);
      }

      return window.FluxCart.add(variantId, quantity || 1, props)
        .then(function (res) {
          self.render(res);
          if (res.item_count !== undefined) {
            self.countEls.forEach(function (el) { el.textContent = res.item_count; });
          }
          toast(opts.successMsg || 'Added to Bag');
          /* 主题设置里关掉抽屉的话，就不要自动弹出来 */
          if (opts.openDrawer !== false) self.open();
          return res;
        })
        .catch(function (err) {
          toast(err.message || 'Could not add to bag', 'error');
          throw err;
        })
        .finally(function () {
          if (drawerNode) drawerNode.classList.remove('cart-loading');
        });
    },

    /* ---- 改数量 ---- */
    changeQty: function (line, delta) {
      var self = this;
      var valEl = $('[data-qty-value="' + line + '"]', this.drawer);
      var current = valEl ? Number(valEl.textContent) : 1;
      var next = current + delta;

      /* 数量减到 0 就等于删除 */
      if (next < 0) return;
      if (next === 0) return this.removeLine(line);

      /* 乐观更新：先把界面上的数字改掉，用户感觉是瞬时的。
         如果服务端返回失败，render() 会用真实数据覆盖回来。 */
      if (valEl) valEl.textContent = next;
      var drawerNode = this.drawer;
      if (drawerNode) drawerNode.classList.add('cart-loading');

      return window.FluxCart.change(line, next)
        .then(function (res) { self.render(res); })
        .catch(function (err) {
          toast(err.message || 'Could not update quantity', 'error');
          /* 失败就重新拉一次真实数据，把乐观更新纠正回来 */
          return window.FluxCart.get().then(function (c) { self.render({ sections: null }); });
        })
        .finally(function () {
          if (drawerNode) drawerNode.classList.remove('cart-loading');
        });
    },

    removeLine: function (line) {
      var self = this;
      var drawerNode = this.drawer;
      if (drawerNode) drawerNode.classList.add('cart-loading');
      return window.FluxCart.remove(line)
        .then(function (res) {
          self.render(res);
          toast('Removed from bag');
        })
        .catch(function (err) {
          toast(err.message || 'Could not remove item', 'error');
        })
        .finally(function () {
          if (drawerNode) drawerNode.classList.remove('cart-loading');
        });
    }
  };

  /* ================================================ 5. 商品卡片快捷加购 */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      if (btn.disabled) return;

      var vid = btn.getAttribute('data-quick-add');
      var original = btn.textContent;

      btn.disabled = true;
      btn.textContent = 'Adding…';

      Cart.add(vid, 1, null, { openDrawer: window.FLUX_OPEN_DRAWER !== false })
        .then(function () {
          btn.textContent = 'Added ✓';
          btn.classList.add('is-added');
          setTimeout(function () {
            btn.textContent = original;
            btn.classList.remove('is-added');
            btn.disabled = false;
          }, 1800);
        })
        .catch(function () {
          btn.textContent = original;
          btn.disabled = false;
        });
    });
  }

  /* ================================================ 6. 商品详情页 */
  function initProduct() {
    var form = $('#FluxProductForm');
    if (!form) return;

    var jsonEl = $('#FluxProductJson');
    if (!jsonEl) return;

    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (err) {
      return;
    }
    if (!product || !product.variants) return;

    var state = {
      variantId: product.selectedVariantId || (product.variants[0] && product.variants[0].id),
      quantity: 1
    };

    var idInput = form.querySelector('[name="id"]');
    var priceWrap = $('#FluxProductPrice');
    var buyBtn = $('#FluxProductBuy');
    var addBtnText = buyBtn ? buyBtn.querySelector('[data-add-text]') : null;

    function findVariant(id) {
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === String(id)) return product.variants[i];
      }
      return null;
    }

    /* ---- 根据当前选中的 option 值，算出应该用哪个 variant ---- */
    function currentOptions() {
      var opts = [];
      $$('[data-option-index]', form).forEach(function (group) {
        var idx = Number(group.getAttribute('data-option-index'));
        var picked = group.querySelector('.opt-btn.is-selected');
        opts[idx] = picked ? picked.getAttribute('data-value') : null;
      });
      return opts;
    }

    function resolveVariant() {
      var opts = currentOptions();
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var match = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] === null || opts[j] === undefined) { match = false; break; }
          if (String(v.options[j]) !== String(opts[j])) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    /* ---- 把某个 option 值「本来就选不到」的按钮置灰 ---- */
    function refreshAvailability() {
      $$('[data-option-index]', form).forEach(function (group) {
        var idx = Number(group.getAttribute('data-option-index'));
        $$('.opt-btn', group).forEach(function (btn) {
          var val = btn.getAttribute('data-value');
          /* 假设这个值被选中，看有没有任何一个 variant 是存在的 */
          var anyAvailable = product.variants.some(function (v) {
            if (String(v.options[idx]) !== String(val)) return false;
            /* 只检查「其它」option 是否符合当前已选 */
            for (var k = 0; k < product.variants[0].options.length; k++) {
              if (k === idx) continue;
              var groupK = $('[data-option-index="' + k + '"]', form);
              var pickedK = groupK ? groupK.querySelector('.opt-btn.is-selected') : null;
              if (pickedK && String(v.options[k]) !== String(pickedK.getAttribute('data-value'))) {
                return false;
              }
            }
            return true;
          });
          var inStock = product.variants.some(function (v) {
            return String(v.options[idx]) === String(val) && v.available;
          });
          btn.disabled = !inStock;
        });
      });
    }

    /* ---- 更新界面：价格 / 主图 / 按钮状态 / URL ---- */
    function updateUI() {
      var v = findVariant(state.variantId);
      if (!v) return;

      if (idInput) idInput.value = v.id;

      /* 价格 */
      if (priceWrap) {
        var html = '';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html += '<s class="price__was">' + money(v.compare_at_price) + '</s>';
        }
        html += '<span class="price__now">' + money(v.price) + '</span>';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
          html += '<span class="price__tag">Save ' + pct + '%</span>';
        }
        priceWrap.innerHTML = html;
      }

      /* 按钮状态 */
      if (buyBtn) {
        if (v.available) {
          buyBtn.disabled = false;
          buyBtn.removeAttribute('disabled');
          if (addBtnText) addBtnText.textContent = product.addToCartText || 'Add to Bag';
        } else {
          buyBtn.disabled = true;
          buyBtn.setAttribute('disabled', 'disabled');
          if (addBtnText) addBtnText.textContent = product.soldOutText || 'Sold Out';
        }
      }

      /* 主图切到该 variant 自己的图（如果设了的话） */
      if (v.featured_media_id) {
        var thumb = $('.pd-thumb[data-media-id="' + v.featured_media_id + '"]');
        if (thumb) selectMedia(thumbIndex(thumb));
      }

      /* 更新 URL，方便买家复制分享这一款 */
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    /* ---- 主图切换 ----
       ★ 一律按「序号」对位，不再按 data-media-id 找元素：
         video_tag / model_viewer_tag 渲染出来的标签不带 data-media-id，
         靠属性匹配会让视频永远拿不到 is-active（CSS 里 .pd-main video 是 opacity:0），
         表现就是「点了视频缩略图没反应，主区还是上一张图」。
         媒体元素在 DOM 里的先后顺序与 product.media 一致，缩略图也同序。 */
    function mediaItems() {
      return $$('.pd-main > img, .pd-main > video, .pd-main > iframe');
    }
    function thumbIndex(t) {
      var n = parseInt(t.getAttribute('data-media-index'), 10);
      if (!isNaN(n)) return n;
      return $$('.pd-thumb').indexOf(t);
    }
    function selectMedia(index) {
      var items = mediaItems();
      items.forEach(function (m, i) {
        m.classList.toggle('is-active', i === index);
      });
      $$('.pd-thumb').forEach(function (t, i) {
        t.classList.toggle('active', i === index);
      });
      /* 视频自动播放（静音循环），用户点到视频缩略图时体验更顺 */
      var activeMain = items[index];
      if (activeMain && activeMain.tagName === 'VIDEO') {
        try { activeMain.currentTime = 0; } catch (e) { /* 忽略 */ }
        var p = activeMain.play();
        if (p && p.catch) p.catch(function () { /* 浏览器拦截自动播放，忽略 */ });
      }
    }

    /* ---- 选项点击 ---- */
    $$('[data-option-index]', form).forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('.opt-btn');
        if (!btn || btn.disabled) return;
        e.preventDefault();

        $$('.opt-btn', group).forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');

        /* 把被选中的值写到「当前选择」那一行文字里 */
        var label = group.querySelector('[data-option-value-label]');
        if (label) label.textContent = btn.getAttribute('data-value');

        var v = resolveVariant();
        if (v) {
          state.variantId = v.id;
          updateUI();
        }
        refreshAvailability();
      });
    });

    /* ---- 缩略图点击 ---- */
    $$('.pd-thumb').forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        selectMedia(thumbIndex(t));
      });
    });

    /* ---- 数量加减 ---- */
    var qtyInput = $('#FluxQtyInput');
    function setQty(n) {
      state.quantity = Math.max(1, Math.min(product.maxQuantity || 99, n));
      if (qtyInput) qtyInput.value = state.quantity;
    }
    var minus = $('#FluxQtyMinus');
    var plus = $('#FluxQtyPlus');
    if (minus) minus.addEventListener('click', function (e) { e.preventDefault(); setQty(state.quantity - 1); });
    if (plus) plus.addEventListener('click', function (e) { e.preventDefault(); setQty(state.quantity + 1); });
    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        setQty(parseInt(qtyInput.value, 10) || 1);
      });
    }

    /* ---- 加购 ---- */
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var v = findVariant(state.variantId);
      if (!v || !v.available) {
        toast(product.soldOutText || 'Sold Out', 'error');
        return;
      }

      /* 收集自定义属性字段（如果有的话） */
      var props = {};
      $$('[data-product-property]', form).forEach(function (f) {
        if (f.value) props[f.getAttribute('data-product-property')] = f.value;
      });

      var openDrawer = form.getAttribute('data-open-drawer') !== 'false';

      if (buyBtn) {
        buyBtn.disabled = true;
        if (addBtnText) addBtnText.textContent = 'Adding…';
      }

      Cart.add(v.id, state.quantity, props, { openDrawer: openDrawer })
        .then(function () {
          if (buyBtn) {
            buyBtn.classList.add('is-added');
            if (addBtnText) addBtnText.textContent = 'Added ✓';
            setTimeout(function () {
              buyBtn.classList.remove('is-added');
              buyBtn.disabled = false;
              if (addBtnText) addBtnText.textContent = product.addToCartText || 'Add to Bag';
            }, 1900);
          }
        })
        .catch(function () {
          if (buyBtn) {
            buyBtn.disabled = false;
            if (addBtnText) addBtnText.textContent = product.addToCartText || 'Add to Bag';
          }
        });
    });

    /* ---- 图片放大灯箱 ---- */
    var lightbox = $('#FluxLightbox');
    if (lightbox && window.FLUX_ZOOM !== false) {
      var lbImg = $('#FluxLightboxImg');
      var items = $$('.pd-main [data-media-id]').filter(function (m) {
        return m.tagName === 'IMG';
      });
      var lbIndex = 0;

      $$('.pd-thumb').forEach(function (t) {
        var mediaId = t.getAttribute('data-media-id');
        var isImage = t.getAttribute('data-type') !== 'video';
        if (!isImage) return;
        t.addEventListener('click', function () {
          items.forEach(function (m, i) {
            if (String(m.getAttribute('data-media-id')) === String(mediaId)) lbIndex = i;
          });
        });
      });

      function showLb(i) {
        if (!items.length) return;
        lbIndex = (i + items.length) % items.length;
        var src = items[lbIndex].getAttribute('data-full-src') || items[lbIndex].src;
        if (lbImg) {
          lbImg.src = src;
          lbImg.alt = items[lbIndex].alt || '';
        }
      }

      var zoomBtn = $('#FluxZoomBtn');
      if (zoomBtn) {
        zoomBtn.addEventListener('click', function (e) {
          e.preventDefault();
          /* 找出当前显示的那张 */
          var active = $('.pd-main [data-media-id].is-active');
          if (active && active.tagName === 'IMG') {
            items.forEach(function (m, i) {
              if (m === active) lbIndex = i;
            });
          }
          showLb(lbIndex);
          lightbox.classList.add('open');
          lockScroll(true);
        });
      }

      $$('[data-lightbox-close]').forEach(function (b) {
        b.addEventListener('click', function () {
          lightbox.classList.remove('open');
          lockScroll(false);
        });
      });
      var prev = $('[data-lightbox-prev]');
      var next = $('[data-lightbox-next]');
      if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); showLb(lbIndex - 1); });
      if (next) next.addEventListener('click', function (e) { e.stopPropagation(); showLb(lbIndex + 1); });

      document.addEventListener('keydown', function (e) {
        if (!lightbox.classList.contains('open')) return;
        if (e.key === 'Escape') { lightbox.classList.remove('open'); lockScroll(false); }
        if (e.key === 'ArrowLeft') showLb(lbIndex - 1);
        if (e.key === 'ArrowRight') showLb(lbIndex + 1);
      });
    }

    refreshAvailability();
    updateUI();
  }

  /* ================================================ 7. 订阅表单 */
  function initNewsletter() {
    $$('form[data-newsletter]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var msgEl = form.parentNode.querySelector('.news-msg');
        var input = form.querySelector('input[type="email"]');
        if (!input) return;

        var email = (input.value || '').trim();
        /* 简单校验：必须有 @ 和点，且不能有空格 */
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          if (msgEl) {
            msgEl.textContent = 'Please enter a valid email address.';
            msgEl.classList.add('is-error');
          }
          return;
        }

        var btn = form.querySelector('button[type="submit"]');
        var original = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = '…'; }

        /* ★ Shopify 的客户表单要 POST 到 /contact 并带上 form_type=customer。
           用 fetch 提交，避免整页跳转，体验更顺。 */
        var data = new FormData(form);
        fetch(form.action, { method: 'POST', body: data })
          .then(function () {
            if (msgEl) {
              msgEl.textContent = 'Thank you — you\'re on the list ✦';
              msgEl.classList.remove('is-error');
            }
            form.reset();
          })
          .catch(function () {
            if (msgEl) {
              msgEl.textContent = 'Something went wrong. Please try again.';
              msgEl.classList.add('is-error');
            }
          })
          .finally(function () {
            if (btn) { btn.disabled = false; btn.textContent = original; }
          });
      });
    });
  }

  /* ================================================ 8. 收藏（本地）+ 收藏抽屉 */
  function initWishlist() {
    var KEY = 'flux_wishlist';
    function read() {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
    }
    function write(arr) {
      try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) { /* 隐私模式下会失败，忽略 */ }
    }
    function esc(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    var saved = read();
    var drawer = $('#FluxWishDrawer');
    var overlay = $('#FluxOverlay');

    /* 更新导航上和抽屉标题里的收藏数量 */
    function paintCount() {
      $$('[data-wish-count]').forEach(function (el) {
        el.textContent = saved.length;
        el.style.display = saved.length ? '' : 'none';
      });
    }

    /* 把已经收藏的心形点亮 / 熄灭（卡片 + 详情页通用） */
    function paintHearts() {
      $$('[data-wish-toggle]').forEach(function (btn) {
        var handle = btn.getAttribute('data-wish-toggle');
        var on = saved.indexOf(handle) > -1;
        btn.classList.toggle('on', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    /* 金额：用 Shopify 的 money_format 模板拼，和购物袋显示一致 */
    function money(cents, fmt) {
      var amount = (cents / 100).toFixed(2);
      var t = fmt || '${{amount}}';
      return t.replace(/\{\{\s*amount\s*\}\}/g, amount);
    }

    function rowHTML(p, fmt) {
      var url = '/products/' + p.handle;
      var img = p.featured_image || (p.images && p.images[0]) || '';
      var v = (p.variants && p.variants[0]) || null;
      var cta;
      if (!p.available) {
        cta = '<button type="button" class="add-btn add-btn--disabled" disabled>Sold Out</button>';
      } else if (v) {
        cta = '<button type="button" class="add-btn" data-quick-add="' + v.id + '">Add to Bag</button>';
      } else {
        cta = '<a class="add-btn add-btn--link" href="' + url + '">View details</a>';
      }
      return '<li class="wish-item">' +
        '<a href="' + url + '" class="wish-item__img">' +
          (img ? '<img src="' + img + '&width=200" alt="" width="72" height="72" loading="lazy" decoding="async">' : '') +
        '</a>' +
        '<div class="wish-item__info">' +
          '<h4><a href="' + url + '">' + esc(p.title) + '</a></h4>' +
          '<div class="wish-item__price">' + money(p.price, fmt) + '</div>' +
          cta +
        '</div>' +
        '<button type="button" class="wish-item__rm" data-wish-toggle="' + p.handle + '" aria-label="Remove from saved">✕</button>' +
        '</li>';
    }

    function emptyHTML() {
      return '<div class="wish-empty">' +
        '<p class="wish-empty__text">Nothing saved yet.</p>' +
        '<p class="wish-empty__sub">Tap the ♡ on any piece you love — it will wait for you here.</p>' +
        '<a href="' + (window.FLUX_ALL_PRODUCTS || '/collections/all') + '" class="btn btn--ghost" data-wish-close>Browse All</a>' +
        '</div>';
    }

    /* 用 localStorage 里的 handle 列表拉商品数据并渲染抽屉内容 */
    function renderDrawer() {
      if (!drawer) return;
      var body = $('#FluxWishBody', drawer);
      if (!body) return;
      var fmt = body.getAttribute('data-money-format') || '';

      if (!saved.length) { body.innerHTML = emptyHTML(); return; }

      body.innerHTML = '<ul class="wish-items"><li class="wish-item wish-item--loading">Loading…</li></ul>';

      var jobs = saved.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      });
      Promise.all(jobs).then(function (list) {
        var rows = '';
        var keep = [];
        list.forEach(function (p) {
          if (p && p.handle) { keep.push(p.handle); rows += rowHTML(p, fmt); }
        });
        /* 请求失败的（下架/删掉的收藏）顺手从列表里清掉 */
        if (keep.length !== saved.length) { saved = keep; write(saved); paintCount(); paintHearts(); }
        body.innerHTML = rows ? '<ul class="wish-items">' + rows + '</ul>' : emptyHTML();
      });
    }

    function open() {
      if (!drawer) return;
      renderDrawer();
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      if (overlay) {
        overlay.hidden = false;
        void overlay.offsetWidth;
        overlay.classList.add('open');
      }
      lockScroll(true);
      var closeBtn = $('[data-wish-close]', drawer);
      if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 260);
    }

    function close() {
      if (!drawer) return;
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      /* 遮罩是和购物袋抽屉共用的：只有购物袋也没开着时才收掉 */
      var cart = $('#FluxCartDrawer');
      if (overlay && !(cart && cart.classList.contains('open'))) {
        overlay.classList.remove('open');
        lockScroll(false);
      }
    }

    /* 给别处（购物袋打开时收起收藏）用的全局入口 */
    window.FluxWish = { open: open, close: close, refresh: renderDrawer };

    /* 打开抽屉的触发点：导航上的心形 */
    $$('[data-wish-open]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });

    /* 关闭按钮（抽屉内容会被重渲染，所以用事件委托绑在抽屉上） */
    if (drawer) {
      drawer.addEventListener('click', function (e) {
        var c = e.target.closest('[data-wish-close]');
        if (c) { e.preventDefault(); close(); }
      });
    }
    if (overlay) overlay.addEventListener('click', function () { close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('open')) close();
    });

    /* 收藏变动后，抽屉开着就实时刷新列表 */
    document.addEventListener('flux:wish-change', function () {
      if (drawer && drawer.classList.contains('open')) renderDrawer();
    });

    paintHearts();
    paintCount();

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wish-toggle]');
      if (!btn) return;
      e.preventDefault();
      var handle = btn.getAttribute('data-wish-toggle');
      var i = saved.indexOf(handle);
      if (i > -1) {
        saved.splice(i, 1);
        btn.classList.remove('on');
        btn.setAttribute('aria-pressed', 'false');
        toast('Removed from saved');
      } else {
        saved.push(handle);
        btn.classList.add('on');
        btn.setAttribute('aria-pressed', 'true');
        toast('Saved ♡');
      }
      write(saved);
      paintCount();
      paintHearts();
      document.dispatchEvent(new CustomEvent('flux:wish-change'));
    });
  }

  /* ================================================ 9. 回到顶部 */
  function initBackTop() {
    var btn = $('#FluxBackTop');
    if (!btn) return;

    window.addEventListener('scroll', function () {
      btn.classList.toggle('show', window.pageYOffset > 700);
    }, { passive: true });

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ================================================ 10. 评价视频点击播放 */
  function initReviewVideos() {
    $$('[data-video-card]').forEach(function (card) {
      var video = card.querySelector('video');
      if (!video) return;
      card.addEventListener('click', function () {
        if (video.paused) {
          /* 同时只允许一个视频在播，避免声音叠在一起 */
          $$('[data-video-card] video').forEach(function (v) {
            if (v !== video) { v.pause(); v.closest('[data-video-card]').classList.remove('is-playing'); }
          });
          video.play();
          card.classList.add('is-playing');
        } else {
          video.pause();
          card.classList.remove('is-playing');
        }
      });
    });
  }

  /* ================================================ 11. 合集页筛选/排序 */
  function initCollectionFilters() {
    var sortSel = $('#FluxSortSelect');
    if (sortSel) {
      sortSel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    /* 价位快捷筛选：拼成 Shopify 原生的 filter 参数 */
    $$('[data-price-filter]').forEach(function (chip) {
      chip.addEventListener('click', function (e) {
        e.preventDefault();
        var url = new URL(window.location.href);
        var range = chip.getAttribute('data-price-filter');
        if (range) {
          url.searchParams.set('filter.v.price.gte', range.split('-')[0]);
          url.searchParams.set('filter.v.price.lte', range.split('-')[1]);
        } else {
          url.searchParams.delete('filter.v.price.gte');
          url.searchParams.delete('filter.v.price.lte');
        }
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ================================================ 启动 */
  function boot() {
    initReveal();
    initCountUp();
    initNav();
    Cart.init();
    initQuickAdd();
    initProduct();
    initNewsletter();
    initWishlist();
    initBackTop();
    initReviewVideos();
    initCollectionFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* 暴露出去给别的脚本用 */
  window.FluxTheme = { toast: toast, Cart: Cart, money: money };
})();
